import React from "react";

import Input from "./input";

// CPF é sempre numérico; usado quando o campo aceita apenas CPF.
export const CPF_MASK = "999.999.999-99";

// No modo combinado a máscara inicial precisa aceitar letras (para o CNPJ
// alfanumérico) e ter um slot extra além dos 11 dígitos do CPF, permitindo
// digitar o 12º caractere que dispara a troca para CNPJ_MASK.
export const CPF_MASK_ALNUM = "***.***.***-***";

// CNPJ alfanumérico: os 12 primeiros caracteres aceitam letras ou dígitos
// ("*" do react-input-mask), os 2 dígitos verificadores seguem numéricos.
export const CNPJ_MASK = "**.***.***/****-99";

export const unmask = value => (value ?? "").replace(/[^a-zA-Z0-9]/g, "");

export const isCnpj = value => {
  const rawValue = unmask(value);
  return rawValue.length > 11 || /[a-zA-Z]/.test(rawValue);
};

export const resolveCpfCnpjMask = (value, { onlyCpf, onlyCnpj } = {}) => {
  if (onlyCpf) return CPF_MASK;
  if (onlyCnpj) return CNPJ_MASK;
  return isCnpj(value) ? CNPJ_MASK : CPF_MASK_ALNUM;
};

// As letras do CNPJ alfanumérico são sempre maiúsculas (inclusive para o
// cálculo dos dígitos verificadores), então normalizamos o que for digitado.
export const upperCaseValue = newState => ({
  ...newState,
  value: newState.value.toUpperCase()
});

export const InputCpfCnpj = ({
  onChange = null,
  onlyCnpj,
  onlyCpf,
  value,
  ...props
}) => {
  const resolveMask = valueParam =>
    resolveCpfCnpjMask(valueParam, { onlyCpf, onlyCnpj });

  const [inputMask, setInputMask] = React.useState(() => resolveMask(value));

  const onChangeCpfCnpj = valueParam => {
    setInputMask(resolveMask(valueParam));
    if (onChange) onChange(valueParam);
  };

  const getDefaultLabel = () => {
    if (onlyCpf) return "CPF";
    if (onlyCnpj) return "CNPJ";
    return "CPF ou CNPJ";
  };

  const getDefaultPlaceholder = () => {
    if (onlyCpf) return "Digite seu CPF";
    if (onlyCnpj) return "Digite seu CNPJ";
    return "Digite seu CPF ou CNPJ";
  };

  return (
    <Input
      label={getDefaultLabel()}
      placeholder={getDefaultPlaceholder()}
      mask={inputMask}
      beforeMaskedValueChange={upperCaseValue}
      onChangeValue={onChangeCpfCnpj}
      {...props}
      maskChar={null}
    />
  );
};

export default InputCpfCnpj;
